<!-- Header -->
<div class="sub-header">
  <div class="container" style="height: 100%;">
    <div class="controls-panel d-flex align-items-center justify-content-between">
      <div class="header-name">IBIS Report</div>
      <div>
        <button type="button" class="btn btn-bvq default ml-2" (click)="goBack()"
          [disabled]="loading">
          <i class="fa fa-angle-left mr-1"></i>
          Back
        </button>
        <button type="button" class="btn btn-bvq ml-2" (click)="saveReport()"
          [disabled]="!reportForm.valid || loading">
          <i class="fa fa-floppy-o mr-1"></i>
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<!-- List of IBIS -->
<div class="container pb-3" [hidden]="loading" id="ibisReport">
  <form #reportForm="ngForm">
    <div class="row">
      <div class="col-md-3 left-panel">
        <div class="items">
          <div class="tutorial" [ngClass]="{'active': item.SELECTED}" *ngFor="let item of navBarItems">
            <div class="name" (click)="onSelect(item)">{{item.NAME}}</div>
          </div>

          <div class="pr-3 mt-4" *ngIf="!ibisReport.FILE_EXIST">
            <!-- File upload -->
            <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)"
              accept="application/pdf" multiple="false" dropZoneLabel="Drop and drop pdf file">
              <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <a class="pick-file" (click)="openFileSelector()">
                  <div class="d-block">
                    <div class="text-center">Drop or Select Files</div>
                  </div>
                </a>
              </ng-template>
            </ngx-file-drop>

            <!-- File Name -->
            <div *ngIf="fileArray?.length > 0" class="file-name">
              {{fileArray[0].name}}
            </div>
          </div>

          <div class="pr-3 mt-4" *ngIf="ibisReport.FILE_EXIST">
            <div class="doc-info"> File already attached. </div>
          </div>

          <!-- Draft + Published Toggle Button -->
          <div class="pr-3 mt-4 toggleBtn">
            <button type="button" class="btn btn-bvq w-100" (click)="toggleDraft()"
              [ngClass]="{'published': !ibisReport.DRAFT}">
              {{ibisReport.DRAFT ? 'Draft' : 'Published'}}
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-9 report-container">
        <div id="BASIC_INFO">
          <!-- Code + Date + Name -->
          <div class="row mt-4">
            <!-- Code -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Code</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.CODE"
                  name="CODE" placeholder="Code" required/>
              </div>
            </div>

            <!-- Date -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Date</label>
                <input type="text" class="form-control" placeholder="MM-YYYY"
                  bsDatepicker [bsConfig]="{ dateInputFormat: 'MM-YYYY' }" [maxDate]="today"
                  [(ngModel)]="ibisReport.DATE" name="Date" readonly required
                  (onShown)="onOpenCalendar($event)" (ngModelChange)="formatDate()"/>
              </div>
            </div>

            <!-- Name -->
            <div class="col-md-6 pr-0">
              <div class="form-group mb-0">
                <label>Name</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.NAME"
                  name="Name" placeholder="Name" required/>
              </div>
            </div>
          </div>

          <!-- Growth Rate Prior + Growth Rate Next -->
          <div class="row mt-4">
            <!-- Growth Rate Prior -->
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label>Prior 5 Years Growth Rate</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.GROWTH_RATE_PRIOR"
                  name="GROWTH_RATE_PRIOR" placeholder="0.00" required oneDigitDecimal/>
              </div>
            </div>

            <!-- Growth Rate Next -->
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label>Next 5 Years Growth Rate</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.GROWTH_RATE_NEXT"
                  name="GROWTH_RATE_NEXT" placeholder="0.00" required oneDigitDecimal/>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <!-- Profit -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Profit</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.PROFIT"
                       name="PROFIT" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>

            <!-- Wages -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Wages</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.WAGES"
                       name="WAGES" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>

            <!-- Purchases -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Purchases</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.PURCHASES"
                       name="PURCHASES" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>

            <!-- Marketing -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Marketing</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.MARKETING"
                       name="MARKETING" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <!-- Depreciation -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Depreciation</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.DEPRECIATION"
                       name="DEPRECIATION" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>

            <!-- Rent -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Rent</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.RENT"
                       name="RENT" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>

            <!-- Utilities -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Utilities</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.UTILITIES"
                       name="UTILITIES" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>

            <!-- Other Costs -->
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label>Other Costs</label>
                <input class="form-control" type="text" [(ngModel)]="ibisReport.DATA.OTHER_COSTS"
                       name="OTHER_COSTS" placeholder="0.00"  oneDigitDecimal/>
              </div>
            </div>
          </div>

        </div>

        <!-- Section 2.11 -->
        <div class="row mt-3" id="FUTURE_PROSPECTS">
          <div class="col-md-12 pr-0">
            <label class="d-flex align-items-end justify-content-between">
              Section 2.11 - Future Prospects for the Business
              <button type="button" class="btn btn-bvq" (click)="getLatestIbisReport(true)">
                Auto Populate
              </button>
            </label>
            <quill-editor name="FUTURE_PROSPECTS" [(ngModel)]="ibisReport.DATA.FUTURE_PROSPECTS"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Industry Definition -->
        <div class="row mt-3" id="INDUSTRY_DEFINITION">
          <div class="col-md-12 pr-0">
            <label>Industry Definition</label>
            <quill-editor name="INDUSTRY_DEFINITION" [(ngModel)]="ibisReport.DATA.INDUSTRY_DEFINITION"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Executive Summary -->
        <div class="row mt-3" id="EXECUTIVE_SUMMARY">
          <div class="col-md-12 pr-0">
            <label>Executive Summary</label>
            <quill-editor name="EXECUTIVE_SUMMARY" [(ngModel)]="ibisReport.DATA.EXECUTIVE_SUMMARY"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Current Performance -->
        <div class="row mt-3" id="CURRENT_PERFORMANCE">
          <div class="col-md-12 pr-0">
            <label>Current Performance</label>
            <quill-editor name="CURRENT_PERFORMANCE" [(ngModel)]="ibisReport.DATA.INDUSTRY_PERFORMANCE"
              [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Products and Services -->
        <div class="row mt-3" id="PRODUCT_SERVICES">
          <div class="col-md-12 pr-0">
            <label>Products and Services</label>
            <quill-editor name="PRODUCT_SERVICES" [(ngModel)]="ibisReport.DATA.PRODUCT_SERVICES"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Industry Cost -->
        <div class="row mt-3" id="INDUSTRY_COST">
          <div class="col-md-12 pr-0">
            <label>Cost Structure Benchmarks</label>
            <quill-editor name="INDUSTRY_COST" [(ngModel)]="ibisReport.DATA.INDUSTRY_COST"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Industry Outlook -->
        <div class="row mt-3" id="INDUSTRY_OUTLOOK">
          <div class="col-md-12 pr-0">
            <label>Industry Outlook</label>
            <quill-editor name="INDUSTRY_OUTLOOK" [(ngModel)]="ibisReport.DATA.INDUSTRY_OUTLOOK"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Industry Outlook Images -->
        <div class="row mt-3" id="INDUSTRY_OUTLOOK_IMG">
          <div class="col-md-12 pr-0">
            <label>Industry Outlook Images</label>
            <quill-editor name="INDUSTRY_OUTLOOK_IMG" [(ngModel)]="ibisReport.DATA.INDUSTRY_OUTLOOK_IMG"
                          [modules]="quillModules"></quill-editor>
          </div>
        </div>

        <!-- Key External Drivers / IBIS Blurbs -->
        <div class="row mt-3" id="EXTERNAL_DRIVERS">
          <div class="col-md-12 pr-0">
            <!-- Blurbs -->
            <label>Key External Drivers / IBIS Blurbs</label>
            <ng-container *ngFor="let item of ibisReport.DATA.EXTERNAL_DRIVERS; let i = index; trackBy: trackByFn;">
              <div>
                <div class="form-group d-flex">
                  <input class="form-control" type="text"
                    [(ngModel)]="ibisReport.DATA.EXTERNAL_DRIVERS[i].HEADER"
                    name="EXTERNAL_DRIVERS_HEADER_{{i}}" placeholder="Header"/>

                  <!-- Most Used -->
                  <div class="form-group mb-0 ml-3" style="width: 140px;">
                    <div class="checkbox-item">
                      <input class="checkbox-custom" type='checkbox' name="EXT_DRIVERS_FAVORITE_{{i}}"
                        id="EXT_DRIVERS_FAVORITE_{{i}}" [(ngModel)]="ibisReport.DATA.EXTERNAL_DRIVERS[i].FAVORITE"/>
                      <label class="checkbox-custom-label" for="EXT_DRIVERS_FAVORITE_{{i}}">Most used</label>
                    </div>
                  </div>

                    <button type="button" class="btn btn-bvq ml-2" (click)="removeIbisPs(i)">
                      <i class="fa fa-trash ml-1"></i>
                      Remove
                    </button>
                </div>
                <div class="mb-4">
                  <quill-editor name="EXTERNAL_DRIVERS_{{i}}"
                    [(ngModel)]="ibisReport.DATA.EXTERNAL_DRIVERS[i].CONTENT"
                    [modules]="quillModules"></quill-editor>
                </div>
              </div>
            </ng-container>

            <!-- Add Button -->
            <div class="text-center">
              <button type="button" class="btn btn-bvq" (click)="addAnother()">
                <i class="fa fa-plus mr-1"></i>
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>

